<script lang="ts">
  import type { PublicationResult } from "../../models/publications.interface";
  import { fileStore } from "../../services/select-files";
  import type { DataFile } from "../../models/data.interface";

  export let pubs;
  export let fields: string[];

  function transform(input: number): string {
    if (input == null) return "";
    if (input < 1000) return `${input} B`;
    if (input < 1000000) return `${(input / 1000).toFixed(2)} KB`;
    if (input < 1000000000) return `${(input / 1000000).toFixed(2)} MB`;
    if (input < 1000000000000) return `${(input / 1000000000).toFixed(2)} GB`;
    return `${(input / 1000000000000).toFixed(2)} TB`;
  }

  function toggleFileSelection(pub: PublicationResult) {
    const isSelected = $fileStore.selectedFiles.some((f) => f.id === pub.id);

    let stations = [];
    if (pub.StationID) {
      stations = [{ id: pub.StationID, name: pub.StationName || pub.StationID }];
    } else if (pub.WBAN) {
      stations = [{ id: pub.WBAN, name: pub.WBAN }];
    }

    const file: DataFile = {
      id: pub.id,
      name: pub.DocumentTitle || pub.Title || pub.id, // Use best available title
      startDate: pub.startDate,
      endDate: pub.endDate,
      fileSize: pub.fileSize,
      stations: stations,
      dataTypes: [], // Publications don't have datatypes in the same way
      filePath: pub.filePath,
      boundingPoints: null,
      centroid: null,
      location: pub.location,

      archiveName: null,
      recId: pub.id,
      tar: null
    };

    if (isSelected) {
      fileStore.remove(file);
    } else {
      fileStore.add(file);
    }
  }
</script>

{#each pubs.results as r (r.id)}
  <div class="card mb-3">
    <div class="card-body">
      {#if r?.DocumentNumber}
        <h5 class="card-title">{r.Series} {r.DocumentNumber}</h5>
        {:else if r?.Title}
        <h5 class="card-title">{r.Title}</h5>
        {:else if r?.DocumentTitle && !r?.StationName}
        <h5 class="card-title">{r.DocumentTitle}</h5>
        {:else if r?.StationName}
        <h5 class="card-title">{r.StationName} {r.startDate?.split("T")[0]}</h5>
        {:else}
        <h5 class="card-title">{r.startDate?.split("T")[0]}</h5>
      {/if}
      <h6 class="card-subtitle text-body-secondary text-muted">
        {#if r?.startDate}<time datetime={r?.startDate}>{r?.startDate?.split("T")[0]}</time>{/if}
        {#if r?.startDate && r?.endDate && r?.startDate.split("T")[0] !== r?.endDate.split("T")[0]}
          ⇒
        {/if}
        {#if r?.endDate && r?.startDate?.split("T")[0] !== r?.endDate.split("T")[0]}<time
            datetime={r?.endDate}>{r.endDate?.split("T")[0]}</time
          >{/if}
        {#if r?.endDate || r?.endDate}
          |
        {/if}
        <span>{transform(r.fileSize)}</span>
      </h6>
    </div>

    <div class="d-flex flex-row justify-content-sm-around my-2 card-text">
      {#each fields as key}
        <div class="d-flex flex-column">
          <span class="fw-semibold">{key}:</span>
          <span>{r?.[key] || ""}</span>
        </div>
      {/each}
    </div>

    <div class="card-footer bg-transparent">
      <div class="d-flex justify-content-between">
        <div>
          <a type="button" class="btn ae-tertiary btn-sm" href={r.filePath} role="button">
            <i class="bi bi-download"></i>
            Download
          </a>
        </div>
        <div>
          <!-- SELECTION BUTTON -->
          <button
            on:click={() => toggleFileSelection(r)}
            type="button"
            class="btn {$fileStore.selectedFiles.some((f) => f.id === r.id)
              ? 'ae-outline-primary'
              : 'ae-secondary'} btn-sm"
          >
            {$fileStore.selectedFiles.some((f) => f.id === r.id) ? "- Deselect" : "+ Select"}
          </button>
        </div>
      </div>
    </div>
  </div>
{/each}
